/*
 * @右侧内容重构copy
 * @Date:   2017-11-30 15:29:05
 * @Author:   yu
 */

'use strict';
angular.module('wechatDetailModule', [])
    .directive('wechatDetail', ["$state", "$location", "$timeout", '$stateParams', 'trsHttpService', 'trsspliceString', 'resourceCenterService', 'modalDialog', 'resCtrModalService', 'ueditorService', '$sce', 'storageListenerService', '$q',
        function($state, $location, $timeout, $stateParams, trsHttpService, trsspliceString, resourceCenterService, modalDialog, resCtrModalService, ueditorService, $sce, storageListenerService, $q) {
            return {
                scope: {
                    rebuildData: '='
                },
                restrict: 'AE',
                templateUrl: './networkResource/classifiedResource/wechat/quickPreview/detail/detail_tpl.html',
                replace: true,
                link: function(scope, iElm, iAttrs, controller) {
                    initStatus();
                    initData();
                    /**
                     * [initStatus description]状态初始化
                     * @return {[type]} [description]
                     */
                    function initStatus() {
                        scope.status = {
                            currModule: "wx",
                        };
                        scope.basicParams = {
                            channelName: scope.status.currModule,
                            typeName: $stateParams.typename,
                            nodeId: $stateParams.nodeid
                        };
                        scope.detailData = [];
                    }
                    /**
                     * [initData description]初始化数据
                     * @return {[type]} [description]
                     */
                    function initData() {
                        if (angular.isDefined(scope.rebuildData)) {
                            requestData();
                        }
                    }
                    /**
                     * [requestData description]获取数据
                     * @return {[type]} [description]
                     */
                    function requestData() {
                        var params = {
                            "typeid": "zyzx",
                            "serviceid": 'wx',
                            "modelid": "detailData",
                            "guid": scope.rebuildData.guid
                            /*,
                                                        "indexName": scope.rebuildData.indexName,*/
                        };
                        scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                            if (data.result == "success") {
                                scope.detailData = data.content[0];
                                scope.detailData.CONTENT = ueditorService.replaceHtmlBlank(scope.detailData.CONTENT); //将html正文中的半角空格换成全角空格
                                scope.detailData.CONTENT = scope.detailData.CONTENT.replace(/(<(?:p|div)[^>]*>(?:<(?:span|b)[^>]*>)*)(?:&nbsp;| |　)*/ig, "$1　　").replace(/(<br[^>]*>)(?:&nbsp;| |　)*/ig, "$1　　").replace(/>　　</g, "\>\<").replace(/text-indent:[^>]*em/g, "text-indent:0em");
                                scope.detailData.CONTENT = data.content[0] && $sce.trustAsHtml(scope.detailData.CONTENT);
                                scope.detailIndexname = data.summary_info.indexName;
                                /*var keywords = scope.detailData.ZB_KEYWORDS5_CHAR;
                                scope.detailData.keywordsArr = keywords.split(";");*/
                                scope.detailData.keywordsArr = scope.detailData.KEYWORDS === "" ? [] : scope.detailData.KEYWORDS.split(";");
                                findReprintCounts();
                            }
                        });
                    }
                    /**
                     * [findReprintCounts description] 获取转载量
                     * @return {[type]} [description]
                     */
                    function findReprintCounts() {
                        var params = {
                            typeid: "zyzx",
                            serviceid: "jtcpg",
                            modelId: "findReprintCounts",
                            tags: scope.detailData.MD5TAG
                        };
                        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                            scope.detailData.reprintCounts = !!data.content[0] ? data.content[0][scope.detailData.MD5TAG] : "0";
                        });
                    }
                    /**
                     * [openTakeDraftModal description]取稿
                     * @return {[type]} [description]
                     */
                    scope.openTakeDraftModal = function() {
                        var params = {
                            serviceid: "mlf_bigdataexchange",
                            methodname: "fetch",
                            guid: scope.rebuildData.guid,
                        };
                        params = angular.extend(params, scope.basicParams);
                        var modalInstance = resCtrModalService.fullTakeDraft(params, false, [scope.rebuildData]);
                        modalInstance.result.then(function(data) {
                            takeDraftDownloadImgs(data).then(function() {
                                storageListenerService.addListenerToResource("takeDraft");
                            });

                        }, function() {
                            storageListenerService.addListenerToResource("takeDraft");
                        });
                    };
                    /**
                     * [takeDraftDownloadImgs description]  图片正在下载中情况，跳转至下载弹窗
                     * @param  {[type]} data [description]
                     * @return {[type]}      [description]
                     */
                    function takeDraftDownloadImgs(data) {
                        var deferred = $q.defer();
                        var needDownloadImg = false;
                        for (var i = 0; i < data.REPORTS.length; i++) {
                            if (data.REPORTS[i].PICERROR == 1) {
                                needDownloadImg = true;
                                break;
                            }
                        }
                        if (needDownloadImg) {
                            resCtrModalService.takeDraftDownloadImgs(data, function(res) {
                                deferred.resolve();
                            });
                        } else {
                            deferred.resolve();
                        }
                        return deferred.promise;
                    }
                    //个人素材
                    scope.creationAxis = function() {
                        var params = angular.copy(scope.basicParams);
                        params.guid = scope.rebuildData.guid;
                        params.indexName = scope.detailIndexname;
                        resourceCenterService.setBigDataCreation(params).then(function(data) {
                            modalDialog.alertType("添加成功", "", "success", false, function() {

                            });
                        });
                    };
                    // 收藏
                    scope.collect = function() {
                        var params = {
                            serviceid: "mlf_bigdataexchange",
                            methodname: "collect",
                            guid: scope.rebuildData.guid,
                        };
                        params.indexName = scope.detailIndexname;
                        params = angular.extend(params, scope.basicParams);
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                            modalDialog.alertType("收藏成功!", "", "success", false, "");
                        });
                    };
                    /**
                     * [plainView description] 返回 普通视图
                     * @return {[type]} [description]
                     */
                    scope.plainView = function() {
                        $state.go("front.networksource.classifiedresource.wechat.resource", $stateParams);
                    };
                }
            };
        }
    ]);